import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';

@Component({
  selector: 'app-product-pallet-form',
  templateUrl: './product-pallet-form.component.html',
  styleUrls: ['./product-pallet-form.component.scss'],
})
export class ProductPalletFormComponent implements OnInit {

  TenantId: any;
  CompanyId: any;
  userId: any;

  @Input() selectedData: any = {}; // added by BURHAN - 8-June-2026 - parent se data aayega
  @Input() isEdit: boolean = false; // added by BURHAN - 8-June-2026
  @Output() onSave = new EventEmitter<any>(); // added by BURHAN - 8-June-2026 - parent ko data bhejenge
  @Output() onClose = new EventEmitter<any>(); // added by BURHAN - 8-June-2026

  isFormSubmit: boolean = false;
  isProductPage: boolean = false; // added by BURHAN - 10-June-2026

  Product: any = {
    lable: "Product",
    dataField: "ProductId",
    isValueBind: true,
    isSearchByApi: true,
    type: "dropdown",
    placeholder: "Select Product",
    isRequired: true,
  };
  Dimension: any = {
    lable: "Pallet Size",
    dataField: "DimensionId",
    isValueBind: true,
    isSearchByApi: true,
    type: "dropdown",
    placeholder: "Select Dimension",
    isRequired: true,
  };
  CaseSize: any = {
    lable: "Case Size",
    dataField: "CaseSize",
    isValueBind: true,
    isSearchByApi: true,
    type: "dropdown",
    placeholder: "Select Case Size",
    isRequired: true,
    isReadOnly: true
  }
  CaseQty: any = {
    lable: 'Case Qty',
    formControlName: 'CaseQty',
    dataField: 'CaseQty',
    placeholder: 'Enter Case Qty',
    type: 'number'
  };
  Qty: any = {
    lable: 'Qty',
    formControlName: 'Qty',
    dataField: 'Qty',
    placeholder: 'Enter Qty',
    type: 'number',
    isReadOnly : true
  };
  Length: any = {
    lable: "Length",
    dataField: 'Length',
    formControlName: 'Length',
    isRequired: false,
    type: 'number',
    placeholder: "Length",
    isReadOnly: true,
    size: 'col-md-4'
  };
  Width: any = {
    lable: "Width",
    dataField: 'Width',
    formControlName: 'Width',
    isRequired: false,
    type: 'number',
    placeholder: "Width",
    isReadOnly: true,
    size: 'col-md-4'
  };
  Height: any = {
    lable: "Height",
    dataField: 'Height',
    formControlName: 'Height',
    isRequired: false,
    type: 'number',
    placeholder: "Height",
    isReadOnly: true,
    size: 'col-md-4'
  };
  CaseLayer: any = {
    lable: 'Case/Layer',
    formControlName: 'CaseLayer',
    dataField: 'CaseLayer',
    placeholder: 'Enter Case/Layer',
    type: 'number',
    isRequired: false
  };
  Level: any = {
    lable: 'Level',
    formControlName: 'Level',
    dataField: 'Level',
    placeholder: 'Enter Level',
    type: 'number',
    isRequired: false
  };
  Weight: any = {
    lable: "Weight (kg)",
    dataField: 'Weight',
    formControlName: 'Weight',
    isRequired: false,
    type: 'number',
    placeholder: "Weight",
    isReadOnly: true
  };
  PalletCode: any = {
    lable: "Pallet/Barcode Code",
    dataField: 'PalletCode',
    formControlName: 'PalletCode',
    type: "text",
    placeholder: "Enter Pallet Code",
    isRequired: true,
    isReadOnly: false
  };
  //end by BURHAN - 8-June-2026

  constructor(
    private toastr: ToastrService,
    private _appService: appService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private mobileDetectionService: MobileDetectionService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
  ) { }

  ngOnInit() {
    this.TenantId = JSON.parse(this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));

    // added by BURHAN - 10-June-2026 - Product page se aaya to prefill + disable
    this.isProductPage = this.selectedData.isProductPage || false;

    if (this.selectedData.ProductId) {
      this.Product.dropdownList = [{
        value: this.selectedData.ProductId,
        name: this.selectedData.ProductName
      }];
      this.selectedData.ProductId = this.selectedData.ProductId; // ensure set

      // Product page se aaya to Product disable, CaseSize enable
      if (this.isProductPage) {
        this.Product.isReadOnly = true;
        this.CaseSize.isReadOnly = false; // Case size open kar do
        // CaseSize list load karo
        //this.GetProductCaseSizeList('', false);
      } else {
        this.CaseSize.isReadOnly = false; // edit mode me normal flow
      }
    }

    if (this.selectedData.CaseSize) {
      this.CaseSize.dropdownList = [{
        value: this.selectedData.CaseSize,
        name: `${this.selectedData.CaseSize} - ${this.selectedData.PackCode}`,
        PackCode: this.selectedData.PackCode
      }];
    }

    if (this.selectedData.DimensionId) {
      this.Dimension.dropdownList = [{
        value: this.selectedData.DimensionId,
        name: this.selectedData.DimensionName,
        Length: this.selectedData.Length,
        Width: this.selectedData.Width,
        Height: this.selectedData.Height,
        Weight: this.selectedData.Weight
      }];
    }

    if (this.isEdit) {
      setTimeout(() => {
        this.calculateQty();
      }, 0);
    }
  }
  GetDimenstionList(value, isScrollDown = false) {
    this.Dimension.isSearch = true;
    this._appService.GetByTwoId('so_GoodsOutward', 'GetDimensionList', value, this.CompanyId).subscribe((res) => {
      this.Dimension.dropdownList = [...res];
      this.Dimension.isSearch = false;
    }, error => {
      this.Dimension.isSearch = false;
    })
  }

  GetProductList(value, isScrollDown = false) {
    this.Product.isSearch = true;
    this._appService.GetByTwoId('so_GoodsOutward', 'GetProductListSelect2', value, this.CompanyId).subscribe((res) => {
      this.Product.dropdownList = [...res];
      this.Product.isSearch = false;
    }, error => {
      this.Product.isSearch = false;
    })
  }

  GetProductCaseSizeList(value, isScrollDown = false) {
    this.CaseSize.isSearch = true;
    this._appService.GetByTwoId('so_GoodsOutward', 'GetProductCaseSizeList', value, this.selectedData.ProductId).subscribe((res) => {
      this.CaseSize.dropdownList = res.map(item => ({
        value: item.value,
        name: item.PackCode,
        PackCode: item.SinglePackcode
      }));

      // if (this.isEdit && this.selectedData.CaseSize) {
      //   const currentValue = typeof this.selectedData.CaseSize === 'object'
      //     ? this.selectedData.CaseSize.value
      //     : this.selectedData.CaseSize;
      //   const matched = this.CaseSize.dropdownList.find(x => x.value == currentValue);
      //   if (matched) {
      //     this.selectedData.CaseSize = matched;
      //   }
      // }

      this.CaseSize.isSearch = false;
    }, error => {
      this.CaseSize.isSearch = false;
    })
  }

  setDropdownData(field: any, value: any, name: any) {
    field.dropdownList = [{ value, name }];
    this.selectedData[field.dataField] = value;
  }

  getChangedValue(value, data) {
    if (data.dataField == 'CaseQty' || data.dataField == 'CaseLayer' || data.dataField == 'Level' || data.dataField == 'PalletCode') {
      this.selectedData[data.dataField] = value;
    }
    else if (data.dataField == 'CaseSize') {
      this.selectedData[data.dataField] = value.value;
      const selectedItem = this.CaseSize.dropdownList.find(x => x.value == value.value);
      if (selectedItem) {
        this.selectedData['PackCode'] = selectedItem.PackCode;
      }
      this.calculateQty();
    }
    else if (data.dataField == 'ProductId') {
      this.selectedData[data.dataField] = value.value;
      this.CaseSize.isReadOnly = false;
      this.selectedData.CaseSize = null;
      this.selectedData.Qty = null;
      this.selectedData.PackCode = null;
      this.CaseSize.dropdownList = [];
      this.GetProductCaseSizeList('', false);
    }
    else if (data.dataField == 'DimensionId') {
      this.selectedData[data.dataField] = value.value;
      this.selectedData['Length'] = value.Length || null;
      this.selectedData['Width'] = value.Width || null;
      this.selectedData['Height'] = value.Height || null;
      this.selectedData['Weight'] = value.Weight || null;
    }
    else {
      this.selectedData[data.dataField] = value.value;
    }

    if (data.dataField == 'CaseQty') {
      this.calculateQty();
    }
  }

  onSaveBtnClick() {
    this.isFormSubmit = true;
    if (!this.selectedData.PalletCode) {
      this.toastr.error('Select Pallet Code', 'Error');
      return;
    }
    if (!this.selectedData.DimensionId) {
      this.toastr.error('Select Dimension', 'Error');
      return;
    }
    if (!this.selectedData.ProductId) {
      this.toastr.error('Select Product', 'Error');
      return;
    }
    if (!this.selectedData.CaseSize) {
      this.toastr.error('Select Case Size', 'Error');
      return;
    }
    if (!this.selectedData.CaseQty || this.selectedData.CaseQty === 0) {
      this.toastr.error('Enter Case Qty', 'Error');
      return;
    }

    const caseSize = Number(this.selectedData.CaseSize);
    const qty = Number(this.selectedData.Qty);
    const caseQty = Number(this.selectedData.CaseQty);
    const caseLayer = Number(this.selectedData.CaseLayer) || 0;
    const level = Number(this.selectedData.Level) || 0;

    if (caseLayer > 0 && level > 0) {
      const calculatedCaseQty = caseLayer * level;
      if (caseQty !== calculatedCaseQty) {
        this.toastr.warning(`Case Qty must be equal to Case/Layer × Level (${caseLayer} × ${level} = ${calculatedCaseQty})`, 'Validation Error');
        return;
      }
    }

    if (qty !== caseSize * caseQty) {
      this.toastr.error('Qty must be equal to Case Size X Case Qty', 'Error');
      return;
    }

    this.selectedData.Id = this.selectedData.Id || null;
    this.isFormSubmit = false;

    // FIX: - added by BURHAN - 10-June-2026
    const saveObj = {
      Id: this.selectedData.Id || null,
      ProductId: this.selectedData.ProductId,
      DimensionId: this.selectedData.DimensionId,
      CaseSize: this.selectedData.CaseSize,
      CaseQty: this.selectedData.CaseQty,
      CaseLayer: this.selectedData.CaseLayer,
      Level: this.selectedData.Level,
      PackCode: this.selectedData.PackCode || '',
      PalletCode: this.selectedData.PalletCode,
      Weight: this.selectedData.Weight,
      UserId: this.userId
    };

    this.onSave.emit(saveObj);
  }

  // onSaveBtnClick() {
  //   this.isFormSubmit = true;
  //   if (!this.selectedData.DimensionId) {
  //     this.toastr.error('Select Dimension', 'Error');
  //     return;
  //   }
  //   if (!this.selectedData.ProductId) {
  //     this.toastr.error('Select Product', 'Error');
  //     return;
  //   }
  //   if (!this.selectedData.CaseSize) {
  //     this.toastr.error('Select Case Size', 'Error');
  //     return;
  //   }
  //   if (!this.selectedData.CaseQty || this.selectedData.CaseQty === 0) {
  //     this.toastr.error('Enter Case Qty', 'Error');
  //     return;
  //   }

  //   const caseSize = Number(this.selectedData.CaseSize);
  //   const qty = Number(this.selectedData.Qty);
  //   const caseQty = Number(this.selectedData.CaseQty);
  //   const caseLayer = Number(this.selectedData.CaseLayer) || 0;
  //   const level = Number(this.selectedData.Level) || 0;

  //   if (caseLayer > 0 && level > 0) {
  //     const calculatedCaseQty = caseLayer * level;
  //     if (caseQty !== calculatedCaseQty) {
  //       this.toastr.warning(`Case Qty must be equal to Case/Layer × Level (${caseLayer} × ${level} = ${calculatedCaseQty})`, 'Validation Error');
  //       return;
  //     }
  //   }

  //   if (qty !== caseSize * caseQty) {
  //     this.toastr.error('Qty must be equal to Case Size X Case Qty', 'Error');
  //     return;
  //   }

  //   this.selectedData.Id = this.selectedData.Id || null;
  //   this.isFormSubmit = false;

  //   const saveObj = {
  //     Id: this.selectedData.Id || null,
  //     ProductId: this.selectedData.ProductId,
  //     DimensionId: this.selectedData.DimensionId,
  //     CaseSize: this.selectedData.CaseSize.value,
  //     CaseQty: this.selectedData.CaseQty,
  //     CaseLayer: this.selectedData.CaseLayer,
  //     Level: this.selectedData.Level,
  //     PackCode: this.selectedData.CaseSize.name.split(' - ')[1] || '',
  //     PalletCode: this.selectedData.PalletCode,
  //     Weight: this.selectedData.Weight,
  //     UserId: this.userId
  //   };

  //   this.onSave.emit(saveObj);
  // }

  calculateQty() {
    const caseSize = Number(this.selectedData.CaseSize) || 0;
    const caseQty = Number(this.selectedData.CaseQty) || 0;
    this.selectedData.Qty = caseSize * caseQty;
    
  }

  close() {
    this.onClose.emit();
  }
}